export const formatCounter = (value: number, isWeb: boolean): string => {
    const formatter = new Intl.NumberFormat('ru-RU');

    if (isWeb) {
        // Веб-версия (до 5 символов)
        if (value < 10000) return formatter.format(value);
        if (value <= 999999) return `${formatter.format(Math.floor(value / 1000))}K`;
        if (value <= 9999999) {
            const millions = (value / 1000000).toFixed(1).replace(/\.0$/, '');
            return `${millions}M`;
        }
        return `${Math.round(value / 1000000)}M`;
    } else {
        // Адаптивная версия (до 4 символов)
        if (value < 10000) return formatter.format(value);
        if (value <= 999999) return `${formatter.format(Math.floor(value / 1000))}K`;
        return `${formatter.format(Math.floor(value / 1000000))}M`;
    }
};